import api from '../utils/api';

// Fetch all Library Books
export const getLibraryBooks = async (headers) => {
  try {
    const response = await api.get('/api/library-books/library-books', headers);
    return response.data;
  } catch (error) {
    console.error('Error fetching library books:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific Library Book by ID
export const getLibraryBookById = async (id, headers) => {
  try {
    const response = await api.get(`/api/library-books/library-books/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error fetching library book with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new Library Book
export const createLibraryBook = async (libraryBookData, headers) => {
  try {
    const response = await api.post('/api/library-books/library-books', libraryBookData, headers);
    return response.data;
  } catch (error) {
    console.error('Error creating library book:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing Library Book
export const updateLibraryBook = async (id, libraryBookData, headers) => {
  try {
    const response = await api.put(`/api/library-books/library-books/${id}`, libraryBookData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error updating library book with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a Library Book
export const deleteLibraryBook = async (id, headers) => {
  try {
    const response = await api.delete(`/api/library-books/library-books/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting library book with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
